import { OnSchedResponse } from '../../OnSchedResponse'
import { OnSchedRest }     from '../../OnSchedRest'
import { OnSchedHelpers } from '../OnSchedHelpers';


export const BookingFormSubmit = (event, element) => {
  var appointmentBM = {};
  var appointmentBookingFields = [];
  var customerBookingFields = [];
  var lastname, firstname;
  var form = document.querySelector(".onsched-form.booking-form");
  let customerSMS = false;

  for (var i = 0; i < form.elements.length; i++) {
      var e = form.elements[i];
      if (OnSchedHelpers.IsEmpty(e.name))
          continue;
      if (e.type === "hidden")
          continue;
      if (e.name === "name")
          appointmentBM[e.name] = e.value;
      else
      if (e.name === "groupSize")
          appointmentBM[e.name] = e.value;
      else
      if (e.name === "firstname")
          firstname = e.value;
      else
      if (e.name === "lastname")
          lastname = e.value;
      else
      if (e.name === "customerSMS")
          customerSMS = e.checked;
      else {
          // need to handle booking fields different than other form fields
          if (e.dataset.bookingfield == "appointment" || e.dataset.bookingfield == "customer") {
              var bookingField = {};        
              bookingField["name"] = e.name;
              bookingField["value"] = e.value;  
              if (e.dataset.bookingfield == "appointment")
                  appointmentBookingFields.push(bookingField);
              else
                  customerBookingFields.push(bookingField);
          }
          else
              appointmentBM[e.name] = e.value;
      }
  }

  var name = "";
  if (OnSchedHelpers.IsEmpty(firstname) === false)
      name = firstname + " ";
  if (OnSchedHelpers.IsEmpty(lastname) === false)
      name += lastname;
  if (OnSchedHelpers.IsEmpty(name) === false)
      appointmentBM["name"] = name;

  appointmentBM.appointmentBookingFields = appointmentBookingFields;
  appointmentBM.customerBookingFields = customerBookingFields;

  if (element.params.appointmentBM != null) {
      appointmentBM.customFields = element.params.appointmentBM.customFields;
  }

  var id = document.querySelector(".onsched-form.booking-form input[name=onsched-appointment-id]").value;
  var appointmentsUrl = element.onsched.apiBaseUrl + "/appointments/" + id + "/book";
  
  // Check if CustomerSMS option is provided
  if (element.options.customerSMS && appointmentBM.phone?.length && customerSMS) {
    var customerUrl = element.onsched.apiBaseUrl + "/customers/";
    
    // Search for existing customer by email
    OnSchedRest.Get(customerUrl+ "?email=" + appointmentBM.email, function (getCustomerResponse) {
      // Check if Customer exists
      if (getCustomerResponse.total > 0) {
        var customerFound = getCustomerResponse.data[0]

        // Check if Customer phone doesn't exists
        if (customerFound.contact.phoneType !== "M" ||
            // Check if Customer phone type is NOT Mobile
            !customerFound.contact.mobilePhone?.length ||
            // Check if Customer phone is different
            customerFound.contact.mobilePhone !== appointmentBM.phone ||
            // Check if Customer notificationType is NOT set to SMS
            customerFound.notificationType !== "3") {
              var customerData = {}
              customerData.contact = {};
              customerData.notificationType = "3";
              customerData.contact.phoneType = "M";
              customerData.contact.mobilePhone = appointmentBM.phone;
              
              // Update Customer SMS notification type & mobile number
              OnSchedRest.Put(customerUrl + customerFound.id, customerData, function (updateCustomerResponse) {
                // Complete Appointment Book
                OnSchedRest.Put(appointmentsUrl, appointmentBM, function (putAppointmentResponse) {
                  OnSchedResponse.PutAppointmentBook(element, putAppointmentResponse);
                });
              });
        }
        else {
          // Complete Appointment Book
          OnSchedRest.Put(appointmentsUrl, appointmentBM, function (putAppointmentResponse) {
            OnSchedResponse.PutAppointmentBook(element, putAppointmentResponse);
          });
        }
      }
      else {
        // No Customer exists
        var customerData = {}
        customerData.contact = {};
        customerData.type = 0;
        customerData.notificationType = "3";
        customerData.name = appointmentBM.name;
        customerData.firstname = OnSchedHelpers.SplitFullName(appointmentBM.name).firstname;
        customerData.lastname = OnSchedHelpers.SplitFullName(appointmentBM.name).lastname;
        customerData.email = appointmentBM.email;
        customerData.contact.phoneType = "M";
        customerData.contact.mobilePhone = appointmentBM.phone;

        // Create new Customer record with mobile phone and SMS notification type
        OnSchedRest.Post(customerUrl, customerData, function (response) {
          // Complete Appointment Book
          OnSchedRest.Put(appointmentsUrl, appointmentBM, function (response) {
            OnSchedResponse.PutAppointmentBook(element, response);
          });
        });
      }
    })

  }
  else {
    // No Customer phone exists
    // Complete Appointment Book
    OnSchedRest.Put(appointmentsUrl, appointmentBM, function (response) {
        OnSchedResponse.PutAppointmentBook(element, response);
    });
  }
}
